export default __webpack_public_path__ + "static/media/release.39dc5989.svg";